import { useEffect, useState } from 'react';

import { getTimestampExpirationCountdown } from '@/utils/timeUtils';

/**
 *
 * @param expirationTimestamp seconds
 */
export const useCountDown = (expirationTimestamp: number) => {
  const [timeToGo, setTimeToGo] = useState<{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  } | null>(null);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    const updateCountdown = () => {
      const countdown = getTimestampExpirationCountdown(expirationTimestamp);
      setTimeToGo(countdown);

      if (countdown.days === -1 && interval) {
        clearInterval(interval);
      }
    };

    updateCountdown();
    interval = setInterval(updateCountdown, 1000);

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [expirationTimestamp]);

  return timeToGo;
};
